interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 px-3 text-sm text-foreground-700 whitespace-nowrap cursor-pointer hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {start > 1 && (
        <>
          <PageBtn value={1} page={page} onChange={onChange} />
          {start > 2 && <span className="px-1 text-foreground-400">…</span>}
        </>
      )}

      {pages.map((p) => (
        <PageBtn key={p} value={p} page={page} onChange={onChange} />
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="px-1 text-foreground-400">…</span>}
          <PageBtn value={totalPages} page={page} onChange={onChange} />
        </>
      )}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 px-3 text-sm text-foreground-700 whitespace-nowrap cursor-pointer hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}

function PageBtn({
  value,
  page,
  onChange,
}: {
  value: number;
  page: number;
  onChange: (p: number) => void;
}) {
  const active = value === page;
  return (
    <button
      type="button"
      onClick={() => onChange(value)}
      aria-current={active ? "page" : undefined}
      className={`h-9 w-9 rounded-md text-sm font-medium cursor-pointer transition-colors ${
        active
          ? "bg-primary-500 text-background-50"
          : "border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
      }`}
    >
      {value}
    </button>
  );
}